import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { useCurrentBreakpoint } from "../../../../hooks/useCurrentBreakpoint";
import { FlavorFinderResetButton, FlavorFinderResultsButton } from "../Buttons/FlavorFinderButtons";
import { FlavorFinderHeader } from "../Header/FlavorFinderHeader";
import { useFlavorFinderContext } from "../Provider/FlavorFinderContextProvider";
import { FlavorFinderResultCard } from "../ResultCard/FlavorFinderResultCard";
import { FlavorFinderResultSuggestionCard } from "../ResultSuggestionCard/FlavorFinderResultSuggestionCard";
import "./FlavorFinderResults.scss";
export const FlavorFinderResults = ({ results }) => {
    const { resetQuiz, flavorFinderData } = useFlavorFinderContext();
    const { results: quizResults } = results;
    const { finalActionCtaLabel, finalActionCtaLink, redoCtaLabel, result } = flavorFinderData;
    const { title, subtitle, flavorLabel, intensityLabel, coolingLabel, deviceSuggestion } = flavorFinderData.result;
    const [activeIndex, setActiveIndex] = useState(0);
    const { isSmall } = useCurrentBreakpoint();
    const [useResultsWithDevice, setUseResultsWithDevice] = useState("");
    const buttonUrl = useMemo(() => {
        const { resultsLinkWithDevice, resultsLink } = results;
        const deviceSuggestionCardEnabled = result.deviceSuggestionCardEnabled;
        const isUseResultsWithDeviceYes = useResultsWithDevice === "yes" || !useResultsWithDevice;
        const isUseResultsWithDeviceNo = useResultsWithDevice === "no";
        if (deviceSuggestionCardEnabled) {
            if (isUseResultsWithDeviceYes && resultsLinkWithDevice) {
                return resultsLinkWithDevice;
            }
            if (isUseResultsWithDeviceNo && resultsLink) {
                return resultsLink;
            }
        }
        else if (resultsLink) {
            return resultsLink;
        }
        return finalActionCtaLink || "#";
    }, [useResultsWithDevice, results, finalActionCtaLink]);
    const handleNextStepClick = async () => {
        await dispatchTrackingEvent(TrackingEvents.TrackingCtaClick, {
            cta_name: finalActionCtaLabel,
            cta_location: "flavor-finder-results",
        });
        window.location.href = buttonUrl;
    };
    const handleSuggestionSelectionChange = (value) => {
        setUseResultsWithDevice(value);
    };
    const toggleActive = (index) => {
        setActiveIndex((prevIndex) => (prevIndex === index ? -1 : index));
    };
    useEffect(() => {
        dispatchTrackingEvent(TrackingEvents.TrackingFlavorFinderResult);
    }, []);
    return (_jsxs("div", { className: "flavorfinder__questions-wrapper", "data-testid": "flavor-finder-question", children: [isSmall && _jsx(FlavorFinderResetButton, { onClick: resetQuiz, label: redoCtaLabel }), _jsx("div", { className: "flavorfinder__question-container", children: _jsxs("div", { className: "flavorfinder__question", children: [_jsx(FlavorFinderHeader, { title: title, subtitle: subtitle, children: !isSmall && _jsx(FlavorFinderResetButton, { onClick: resetQuiz, label: redoCtaLabel }) }), _jsxs("div", { className: "flavorfinder__results", children: [quizResults?.map((result, index) => (_jsx(FlavorFinderResultCard, { result: result, flavorLabel: flavorLabel, intensityLabel: intensityLabel, coolingLabel: coolingLabel, isHiglighted: index === activeIndex, onClick: () => toggleActive(index), index: index }, result.sku))) ?? null, result.deviceSuggestionCardEnabled && (_jsx(FlavorFinderResultSuggestionCard, { description: deviceSuggestion.description, imgUrl: deviceSuggestion.imgUrl, useResultsWithDeviceLink: deviceSuggestion.defaultDeviceSuggestionState, onSelectionChange: handleSuggestionSelectionChange }))] }), _jsx("div", { className: "flavorfinder__footer", children: _jsx(FlavorFinderResultsButton, { onClick: handleNextStepClick, label: finalActionCtaLabel }) })] }) })] }));
};
//# sourceMappingURL=FlavorFinderResults.js.map